export default "__VITE_ASSET__BVxgvnuZ__"